export default function AttachFindingDocumentDirective() {
  return {
    template: require('./attach-finding-document.html'),
    scope: {
      customerId: '=',
      findingId: '=',
      serviceId: '=',
      parentDocumentId: '=',
      documentId: '=',
      document: '=',
    },
    controller: 'AttachFindingDocumentController',
    controllerAs: 'attachFindingDocumentVM',
    bindToController: true,
    replace: true
  };
}
